import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import PropTypes from 'prop-types';
import { Loader } from '@ferris/react/components/loader';
import withPageFlow from '../../PageFlow/PageFlow';

export const LoginInterstitial = (props) => {
    const {
        pageFlow
    } = props;

    useEffect(() => {
        pageFlow.next();
    }, []);

    return (
        <div className="update-account-wrapper">
            <Loader visible />
        </div>
    );
};

LoginInterstitial.propTypes = {
    pageFlow: PropTypes.shape({
        next: PropTypes.func
    }).isRequired
};

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const { app, lead } = state;
    const { missingInfo } = lead;
    const { hasPhoneNumber, hasPasswordSet } = missingInfo || {};
    const {
        isLoggedIn,
        loggedInUserType,
        hasAdvertiserForSite
    } = app;
    return ({
        isLoggedIn,
        loggedInUserType,
        hasAdvertiserForSite,
        hasPhoneNumber,
        hasPasswordSet
    });
};

const ConnectedLoginInterstitial = connect(mapStateToProps)(LoginInterstitial);
ConnectedLoginInterstitial.displayName = 'LoginInterstitial';
export default hot(module)(withPageFlow(ConnectedLoginInterstitial));
